import React, { useState } from "react";

import Barchart from "components/Graphs/Barchart";
import { currencyFormat, getFieldValue, getValue } from "components/Screens/CommonUtils";

import {
  VisibilityOutlined as VisibilityOutlinedIcon,
  VisibilityOffOutlined as VisibilityOffOutlinedIcon,
} from "@mui/icons-material";

import "./PayrollBar.scss";

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function PayrollBar({ payrollData }) {
  const payrollDataRows = payrollData?.payload?.rows || [];
  const latestPayrollData = payrollDataRows[0];
  const secondLatestPayrollData = payrollDataRows[1];
  const latestGross = currencyFormat(getValue(latestPayrollData?.grossAmount));

  const calculateRaise = () => {
    const secondLatestGross = parseFloat(secondLatestPayrollData?.grossAmount);

    if (!latestGross || !secondLatestGross) {
      return 0;
    }

    const raise = latestGross - secondLatestGross;
    return raise > 0 ? raise.toFixed(2) : 0;
  };

  const raise = calculateRaise();

  const [payrollVisibility, setPayrollVisibility] = useState(false);
  const [hiddenFigure, setHiddenFigure] = useState("******");

  const handlePayrollVisibilityChange = () => {
    setHiddenFigure("*".repeat(latestGross?.length || 4));
    setPayrollVisibility(!payrollVisibility);
  };

  return (
    <div className="ep-payroll-bar">
      <div className="ep-payroll-bar-meta">
        <div>
          <div className="ep-payroll-last-month">
            <div className="ep-payroll-dollar">$</div>

            <div className="ep-payroll-amount" id="payroll-amount">
              {!payrollVisibility ? `${latestGross}` : `${hiddenFigure}`}
            </div>
          </div>
          <div className="ep-payroll-gross">{`${
            monthNames[new Date(latestPayrollData?.payslipMonth).getMonth()]
          }’s gross salary`}</div>
          <div className="ep-payroll-bonus-raise" id="bonus-raise-employee">
            {getFieldValue(latestPayrollData?.clientBonus)} Bonus | {getFieldValue(raise)} Raise
          </div>
        </div>
        <div>
          {!payrollVisibility ? (
            <VisibilityOutlinedIcon className="ep-payroll-visibility-icon" onClick={handlePayrollVisibilityChange} />
          ) : (
            <VisibilityOffOutlinedIcon className="ep-payroll-visibility-icon" onClick={handlePayrollVisibilityChange} />
          )}
        </div>
      </div>

      <div className="ep-payroll-bar-divider" />

      <div>
        <Barchart
          payrollData={
            payrollData?.ok
              ? payrollDataRows
                  .map((r) => ({
                    month: monthNames[new Date(r?.payslipMonth).getMonth()],
                    amount: Number(r?.grossAmount || 0),
                  }))
                  .slice(-6)
              : []
          }
        />
      </div>
    </div>
  );
}

export default PayrollBar;
